import { Outlet } from 'react-router-dom';
import { useAnalyticsGtm } from '@unbooking/analytics-gtm';
import { useAuth } from '@unbooking/ui-auth';
import { useUser } from '../../common/hooks';

const AnalyticsLayout = () => {
  const { isAuthenticated, userEmail } = useAuth();
  const userInfo = useUser();

  useAnalyticsGtm({
    authState: { isAuthenticated, userEmail },
    config: {
      serviceName: 'WFP Road Safety Academy',
      loginFlowPrefixes: ['/login', '/callback'],
      agencyName: userInfo?.agency_of_reference_domain ?? 'no agency',
    },
  });

  return <Outlet />;
};

export default AnalyticsLayout;
